import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Theme, useTheme } from '@mui/material';

import { StatusChip } from '@/shared/ui/StatusChip';

import { AwbStatusTone, getAwbListStatus } from '../model/allAwbs';
import { ShipmentStatusValue } from '../model/shipmentStatus';

interface AwbStatusChipProps {
  shipment: { status: ShipmentStatusValue };
  testId?: string;
}

const toneColor = (theme: Theme, tone: AwbStatusTone): string =>
  ({
    pickup: theme.palette.orange[500],
    transit: theme.palette.blue[500],
    delivered: theme.palette.green[500],
    cancelled: theme.palette.grey[400],
    pending: theme.palette.grey[600],
    exception: theme.palette.red[500],
  })[tone];

const AwbStatusChip: FC<AwbStatusChipProps> = ({ shipment, testId }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const status = getAwbListStatus(shipment);

  return (
    <StatusChip label={t(status.labelKey)} bg={toneColor(theme, status.tone)} testId={testId} />
  );
};

export default AwbStatusChip;
